<template>
  <div class="mx-auto my-2">
    <v-card class="mx-4" flat>
      <v-card-title>
        Accreditor Report
        <v-spacer></v-spacer>

        <div class="ml-12">
          <download-excel
 v-if="$can('accreditor-report', 'export')"              :data="selected"
              :fields="export_fields"
              name="accrditorReport.xls"
              type="csv"
          >
            <v-btn
                class="teal white--text"
                color="primary"
                dark
                depressed
                small
            >
              <v-icon left>mdi-export</v-icon>
              <span>Export</span>
            </v-btn>
          </download-excel>
        </div>
      </v-card-title>
      <v-data-table
          v-model="selected"
          :headers="headers"
          :items="accreditorReports.rows"
          :loading="loading"
          :options.sync="options"
          :server-items-length="accreditorReports.count"
          class="elevation-1"
          loading-text="Loading... please wait"
          show-select
      >
        <template v-slot:top>
          <v-layout class="p-3" row wrap>
            <v-flex class="p-3" lg4 md4 sm2 xl3 xs1>
              <v-text-field
                  v-model="accreditorValue"
                  hide-details
                  label="Accreditor Name"
                  single-line
                  type="text"
              ></v-text-field>
            </v-flex>
            <v-flex class="p-3" lg4 md4 sm2 xl3 xs1>
              <v-text-field
                  v-model="accreditorCodeValue"
                  label="Accreditation Code"
                  type="text"
              ></v-text-field>
            </v-flex>
            <v-flex class="p-3" lg4 md4 sm2 xl3 xs1>
              <v-layout class="p-3" row wrap>
                <v-flex xs9>
                  <v-text-field
                      v-model="cpdProviderValue"
                      label="No. of CPD Providers"
                      type="number"
                  ></v-text-field
                  >
                </v-flex>
                <v-flex style="margin-top: 10px" xs3>
                  <v-select
                      v-model="cpdProvcomparisonValue"
                      :items="comparisons"
                      class="comparisonSelect"
                      dense
                      item-text="name"
                      item-value="value"
                      solo
                  ></v-select
                  >
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex class="p-3" lg4 md4 sm2 xl3 xs1>
              <v-layout class="p-3" row wrap>
                <v-flex xs9>
                  <v-text-field
                      v-model="programValue"
                      label="No. of CPD Activities"
                      type="number"
                  ></v-text-field
                  >
                </v-flex>
                <v-flex style="margin-top: 10px" xs3>
                  <v-select
                      v-model="cpdActcomparisonValue"
                      :items="comparisons"
                      class="comparisonSelect"
                      dense
                      item-text="name"
                      item-value="value"
                      solo
                  ></v-select
                  >
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex class="p-3" lg4 md4 sm2 xl3 xs1>
              <v-layout class="p-3" row wrap>
                <v-flex xs9>
                  <v-text-field
                      v-model="courseValue"
                      label="No. of Courses"
                      type="number"
                  ></v-text-field
                  >
                </v-flex>
                <v-flex style="margin-top: 10px" xs3>
                  <v-select
                      v-model="courseComparisonValue"
                      :items="comparisons"
                      class="comparisonSelect"
                      dense
                      item-text="name"
                      item-value="value"
                      solo
                  ></v-select
                  >
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex class="p-3" lg4 md4 sm2 xl3 xs1>
              <v-select
                  v-model="dateRangePreset"
                  :items="dateRangePresets"
                  item-text="text"
                  item-value="value"
                  clearable
                  label="Quick Range"
              ></v-select>
            </v-flex>
            <v-flex class="p-3" lg4 md4 sm2 xl3 xs1>
              <v-select
                  v-model="dateRangeYear"
                  :items="dateRangeYears"
                  clearable
                  label="Year"
              ></v-select>
            </v-flex>
            <v-flex v-if="dateRangePreset && dateRangePreset !== 'yearly'" class="p-3" lg4 md4 sm2 xl3 xs1>
              <v-select
                  v-model="dateRangePeriod"
                  :items="getPresetPeriodOptions(dateRangePreset)"
                  :disabled="!dateRangePreset || dateRangePreset === 'yearly'"
                  clearable
                  label="Period"
              ></v-select>
            </v-flex>
            <v-flex class="p-3" lg4 md4 sm2 xl3 xs1>
              <v-menu
                  ref="startMenu"
                  v-model="startMenu"
                  :close-on-content-click="false"
                  max-width="290px"
                  min-width="290px"
                  offset-y
                  transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="startDateValue"
                      :clearable="true"
                      persistent-hint
                      placeholder="Start Date"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="startDateValue"
                    no-title
                    scrollable
                    @input="startMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex class="p-3" lg4 md4 sm2 xl3 xs1>
              <v-menu
                  ref="endMenu"
                  v-model="endMenu"
                  :close-on-content-click="false"
                  max-width="290px"
                  min-width="290px"
                  offset-y
                  transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="endDateValue"
                      :clearable="true"
                      persistent-hint
                      placeholder="End Date"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="endDateValue"
                    no-title
                    scrollable
                    @input="endMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex class="p-3" lg4 md4 sm2 xl3 xs1>
              <v-switch v-model="statusValue" :label="
                `${ statusValue === true
                  ? 'Active'
                  : 'Not Active'
                }`
              " class="black--text"></v-switch>
            </v-flex>
          </v-layout>
        </template>
        <template v-slot:[`item.accreditorName`]="{ item }">
          <label for="item">{{
              item.accreditorName ? item.accreditorName : "-"
            }}</label>
        </template>
        <template v-slot:[`item.isActive`]="{ item }">
          <v-chip :color="getColor(item.isActive)" dark>
            {{ item.isActive == true ? "Active" : "Not Active" }}
          </v-chip>
        </template>
        <template v-slot:[`item.accreditorOwnership`]="{ item }">
          <label for="item">{{
              item.accreditorOwnership ? item.accreditorOwnership : "-"
            }}</label>
        </template>
        <template v-slot:[`item.accreditorGeolocation`]="{ item }">
          <label for="item">{{
              item.accreditorGeolocation ? item.accreditorGeolocation : "-"
            }}</label>
        </template>
        <template v-slot:[`item.accreditorDirectorName`]="{ item }">
          <label for="item">{{
              item.accreditorDirectorName ? item.accreditorDirectorName : "-"
            }}</label>
        </template>
        <template v-slot:[`item.institutionalEmail`]="{ item }">
          <label for="item">{{
              item.institutionalEmail ? item.institutionalEmail : "-"
            }}</label>
        </template>
        <template v-slot:[`item.institutionalPhone`]="{ item }">
          <label for="item">{{
              item.institutionalPhone ? item.institutionalPhone : "-"
            }}</label>
        </template>
        <template v-slot:[`item.director_email`]="{ item }">
          <label for="item">{{
              item.director_email ? item.director_email : "-"
            }}</label>
        </template>
        <template v-slot:[`item.director_phone`]="{ item }">
          <label for="item">{{
              item.director_phone ? item.director_phone : "-"
            }}</label>
        </template>
        <template v-slot:[`item.accreditationCode`]="{ item }">
          <label for="item">{{
              item.accreditationCode ? item.accreditationCode : "-"
            }}</label>
        </template>
        <template v-slot:[`item.accreditationDate`]="{ item }">
          <label for="item">{{
              item.accreditationDate ? item.accreditationDate : "-"
            }}</label>
        </template>
        <template v-slot:[`item.renewalDate`]="{ item }">
          <label for="item">{{
              item.renewalDate ? item.renewalDate : "-"
            }}</label>
        </template>
        <template v-slot:[`item.noOfCourse`]="{ item }">
          <label for="item">{{
              item.noOfCourse ? item.noOfCourse : "-"
            }}</label>
        </template>
        <template v-slot:[`item.noOfCpdActivity`]="{ item }">
          <label for="item">{{
              item.noOfCpdActivity ? item.noOfCpdActivity : "0"
            }}</label>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import {getUser} from "@/utils/helper";
import {AccreditorReportService} from "./accreditor-report-service";
import reportDateRangeMixin from "@/mixins/reportDateRangeMixin";

export default {
  mixins: [reportDateRangeMixin],
  data() {
    return {
      selected: [],
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      search: "",
      export_fields: {
        "Accreditor's Name": "accreditorName",
        "Accreditor's Status": {
          field: "isActive",
          callback: (value) => {
            const resp = value !== null ? (value ? 'Active' : 'Not Active') : '-';
            return resp;
          }
        },
        "Accreditor's Ownership": "accreditorOwnership",
        "Accreditor's Geolocation": "accreditorGeolocation",
        "Accreditor's Director Name": "accreditorDirectorName",
        "Institutional Email": "institutionalEmail",
        "Institutional Phone": "institutionalPhone",
        "Accreditor's Director Email": "director_email",
        "Accreditor's Director Phone": "director_phone",
        "Accreditation Code": "accreditationCode",
        "Accreditation Date": "accreditationDate",
        "Next Renewal Date": "renewalDate",
        "No. of CPD Provider": "noOfCpdProvider",
        "No. of Courses": "noOfCourse",
      },
      headers: [
        {text: "Accreditor's Name", value: "accreditorName"},
        {text: "Accreditor's Status", value: "isActive", align: "center"},
        {text: "Accreditor's Ownership", value: "accreditorOwnership"},
        {text: "Accreditor's Geolocation", value: "accreditorGeolocation"},
        {text: "Accreditor's Director Name", value: "accreditorDirectorName"},
        {text: "Institutional Email", value: "institutionalEmail"},
        {text: "Institutional Phone", value: "institutionalPhone"},
        {
          text: "Accreditor's Director Email",
          value: "director_email",
        },
        {
          text: "Accreditor's Director Phone",
          value: "director_phone",
        },
        {
          text: "Accreditation Code",
          value: "accreditationCode"
        },
        {
          text: "Accreditation Date",
          value: "accreditationDate"
        },
        {text: "Next Renewal Date", value: "renewalDate"},
        {
          text: "No. of CPD Provider",
          value: "noOfCpdProvider"
        },
        {
          text: "No. of Courses",
          value: "noOfCourse"
        },
      ],
      accreditorReports: [],
      loading: false,
      clearable: false,
      accreditorValue: null,
      cpdProviderValue: null,
      startDateValue: null,
      endDateValue: null,
      startMenu: false,
      endMenu: false,
      dateRangePreset: null,
      dateRangeYear: null,
      dateRangePeriod: null,
      accreditorCodeValue: null,
      programValue: null,
      comparisons: [
        {name: "=", value: "eq"},
        {name: "<", value: "lt"},
        {name: ">", value: "gt"},
        {name: "<=", value: "lte"},
        {name: ">=", value: "gte"},
      ],
      cpdActcomparisonValue: "eq",
      courseValue: null,
      courseComparisonValue: "eq",
      cpdProvcomparisonValue: "eq",

      statusValue: true,
    };
  },
  async beforeMount() {
    this.fetchAccreditorReports();
  },
  computed: {
    canViewRegistration() {
      return getUser().permissions.some(
          (permission) => permission.menuItem.menuItemName == "Accreditor Report"
      );
    },
  },
  watch: {
    options: {
      handler() {
        this.fetchAccreditorReports();
      },
      deep: true,
    },
    statusValue: function () {
      this.fetchAccreditorReports();
    },
    accreditorValue: function (val) {
      this.accreditorValue = val == '' ? null : val;
      this.fetchAccreditorReports();
    },
    accreditorCodeValue: function (val) {
      this.accreditorCodeValue = val == '' ? null : val;
      this.fetchAccreditorReports();
    },
    cpdProviderValue: function (val) {
      this.cpdProviderValue = val;
      this.fetchAccreditorReports();
    },
    cpdProvcomparisonValue: function (val) {
      this.cpdProvcomparisonValue = val;
      this.fetchAccreditorReports();
    },
    programValue: function (val) {
      this.programValue = val;
      this.fetchAccreditorReports();
    },
    cpdActcomparisonValue: function (val) {
      this.cpdActcomparisonValue = val;
      this.fetchAccreditorReports();
    },
    courseValue: function (val) {
      this.courseValue = val;
      this.fetchAccreditorReports();
    },
    courseComparisonValue: function (val) {
      this.courseComparisonValue = val;
      this.fetchAccreditorReports();
    },
    startDateValue: function (val) {
      this.startDateValue = val == '' ? null : val;
      this.fetchAccreditorReports();
    },
    endDateValue: function (val) {
      this.endDateValue = val == '' ? null : val;
      this.fetchAccreditorReports();
    },
    dateRangePreset: function (val) {
      this.applyPresetWithSelection(val, "startDateValue", "endDateValue", "dateRangeYear", "dateRangePeriod");
    },
    dateRangeYear: function () {
      if (this.dateRangePreset) {
        this.applyPresetWithSelection(this.dateRangePreset, "startDateValue", "endDateValue", "dateRangeYear", "dateRangePeriod");
      }
    },
    dateRangePeriod: function () {
      if (this.dateRangePreset) {
        this.applyPresetWithSelection(this.dateRangePreset, "startDateValue", "endDateValue", "dateRangeYear", "dateRangePeriod");
      }
    },
  },
  methods: {
    async fetchAccreditorReports() {
      this.loading = true;
      const {page, itemsPerPage} = this.options;
      let searchParams = '?';
      itemsPerPage > 0 && (searchParams += `page=${page}&pageSize=${itemsPerPage}`);

      this.accreditorValue !== null && (searchParams += '&accreditorName=' + this.accreditorValue);
      this.accreditorCodeValue !== null && (searchParams += '&accreditationCode=' + this.accreditorCodeValue);
      this.cpdProviderValue !== null && (searchParams += `&noCpdProvider=${this.cpdProviderValue}&cpdProviderSign=${this.cpdProvcomparisonValue}`);
      this.programValue !== null && (searchParams += `&noCpdActivity=${this.programValue}&cpdActivitySign=${this.cpdActcomparisonValue}`);
      this.courseValue !== null && (searchParams += `&noCourse=${this.courseValue}&courceSign=${this.courseComparisonValue}`);
      this.statusValue !== null && (searchParams += '&status=' + this.statusValue);
      this.startDateValue !== null && (searchParams += '&startDate=' + this.startDateValue);
      this.endDateValue !== null && (searchParams += '&endDate=' + this.endDateValue);

      const res = await AccreditorReportService.getAccreditorReportstWP(searchParams);
      if (res.status === 200) {
        this.loading = false;
        this.accreditorReports = res.data;
      } else {
        this.loading = false;
        this.$toast.error(
            "There was a problem fetching Accreditor reports, Please try Again!"
        );
      }
    },
    getColor(isActive) {
      if (isActive == false) return "red";
      else return "green";
    },
  },
};
</script>

<style scoped>
.comparisonSelect {
  font-weight: bold;
  font-size: medium;
}
</style>
